@if (menuList$) {
  <ul nz-menu nzTheme="dark" nzMode="inline" [nzInlineCollapsed]="isCollapsed">
    @for (menu of menuList$ | async; track menu) {
      @if (!menu.submenu) {
        <li
          nz-menu-item
          nzMatchRouter
          nz-tooltip
          nzTooltipPlacement="right"
          [nzTooltipTitle]="isCollapsed ? menu.title : ''">
          <a [routerLink]="menu.url">
            <i nz-icon [nzType]="menu.icon"></i> <span>{{ menu.title }}</span>
          </a>
        </li>
      } @else {
        <li nz-submenu [nzTitle]="menu.title" [nzIcon]="menu.icon" [nzOpen]="isActiveSubmenu(menu)">
          <ul>
            @for (submenu of menu.submenu; track submenu) {
              <li nz-menu-item nzMatchRouter>
                <a [routerLink]="submenu.url">
                  <i nz-icon [nzType]="submenu.icon"></i> <span>{{ submenu.title }}</span>
                </a>
              </li>
            }
          </ul>
        </li>
      }
    }
  </ul>
}
